import { API_SUCCESS, API_ERROR } from "./api";
import { normalizeScanPayload } from "../helpers/paymentReconciliationHelper";

export const PAYMENT_RECONCILIATION_REPORT = "PAYMENT_RECONCILIATION_REPORT";
export const PAYMENT_RECONCILIATION_RUN = "PAYMENT_RECONCILIATION_RUN";
export const CLEAR_PAYMENT_RECONCILIATION_ERROR =
  "CLEAR_PAYMENT_RECONCILIATION_ERROR";

export const fetchPaymentReconciliationReport = (filters) => ({
  type: PAYMENT_RECONCILIATION_REPORT,
  payload: filters,
});

export const runPaymentReconciliation = (filters) => ({
  type: PAYMENT_RECONCILIATION_RUN,
  payload: filters,
});

export const clearPaymentReconciliationError = () => ({
  type: CLEAR_PAYMENT_RECONCILIATION_ERROR,
});

const initialState = {
  scanResult: null,
  error: null,
};

function extractErrorMessage(axiosResponse) {
  const data = axiosResponse?.data;
  if (typeof data === "string") return data;
  const body = data?.response ?? data;
  if (typeof body === "string") return body;
  return (
    body?.message ||
    data?.message ||
    data?.error ||
    axiosResponse?.statusText ||
    "Request failed. Please try again."
  );
}

export default function paymentReconciliationReducer(
  state = initialState,
  action
) {
  if (action.type === CLEAR_PAYMENT_RECONCILIATION_ERROR) {
    return { ...state, error: null };
  }

  if (action.type === `${PAYMENT_RECONCILIATION_REPORT} ${API_SUCCESS}`) {
    return {
      ...state,
      scanResult: normalizeScanPayload(action.payload),
      error: null,
    };
  }

  if (action.type === `${PAYMENT_RECONCILIATION_RUN} ${API_SUCCESS}`) {
    return {
      ...state,
      scanResult: normalizeScanPayload(action.payload),
      error: null,
    };
  }

  if (action.type === `${PAYMENT_RECONCILIATION_REPORT} ${API_ERROR}`) {
    return {
      ...state,
      error: extractErrorMessage(action.payload),
    };
  }

  if (action.type === `${PAYMENT_RECONCILIATION_RUN} ${API_ERROR}`) {
    return {
      ...state,
      error: extractErrorMessage(action.payload),
    };
  }

  return state;
}

export const selectPaymentReconciliationScan = (state) =>
  state.paymentReconciliation?.scanResult ?? null;

export const selectPaymentReconciliationError = (state) =>
  state.paymentReconciliation?.error ?? null;
